var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSitemapPageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    fill: "none",
    focusable: "false",
    height: 40,
    stroke: "none",
    viewBox: "0 0 40 40",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M20 36C28.8365 36 36 28.8365 36 20C36 11.1635 28.8365 4 20 4C11.1635 4 4 11.1635 4 20C4 28.8365 11.1635 36 20 36ZM20 6.97933C27.191 6.97933 33.0207 12.809 33.0207 20C33.0207 27.191 27.191 33.0207 20 33.0207C12.809 33.0207 6.97933 27.191 6.97933 20C6.97933 12.809 12.809 6.97933 20 6.97933Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5243 19.0436V25.7471C18.5243 26.5698 19.1912 27.2367 20.014 27.2367C20.8367 27.2367 21.5036 26.5698 21.5036 25.7471V19.0436C21.5036 18.2208 20.8367 17.5539 20.014 17.5539C19.1912 17.5539 18.5243 18.2208 18.5243 19.0436Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5243 14.5746V14.6928C18.5243 15.5156 19.1912 16.1825 20.014 16.1825C20.8367 16.1825 21.5036 15.5156 21.5036 14.6928V14.5746C21.5036 13.7518 20.8367 13.0849 20.014 13.0849C19.1912 13.0849 18.5243 13.7518 18.5243 14.5746Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitemapPageIcon);
export default __webpack_public_path__ + "static/media/SitemapPageIcon.c3cb32a28575ceb2e911656d1ace20df.svg";
export { ForwardRef as ReactComponent };